import { render, staticRenderFns } from "./dialog-order-input.vue?vue&type=template&id=b11b5a02&"
import script from "./dialog-order-input.vue?vue&type=script&lang=js&"
export * from "./dialog-order-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports